import { render } from "./OapDsfAppVtoWrapper.vue?vue&type=template&id=13550774"
import script from "./OapDsfAppVtoWrapper.vue?vue&type=script&lang=js"
export * from "./OapDsfAppVtoWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__